export default __webpack_public_path__ + "static/media/Footpad's Armbands of the Final Way.bcece43a.jpg";